import type { IUserInfo } from "@/account/account-models";
import type { IMessageInfo } from "@/chats/messenger/messenger-models";
import { Avatar } from "@/common/avatar";
import { EAvatarType } from "@/common/avatar/avatar-helpers";
import { ICONS_MESSENGER } from "@/common/icons/icons-messenger";
import { cn } from "@/utils/cn";
import { renderIf, renderIfTrue } from "@/utils/react-conditional";
import React from "react";

export const GetCreditsPurchaseHeader = React.memo(
  function GetCreditsPurchaseHeader(props: {
    isCompact?: boolean;
    affiliate: IUserInfo;
    message: IMessageInfo;
    hideExpiry?: boolean;
  }) {
    return (
      <div
        className={cn(
          "mb-4 flex items-center text-left",
          props.isCompact ? "justify-center text-center" : "justify-start"
        )}
      >
        {renderIfTrue(!props.isCompact, () => (
          // no `to` prop: this also renders inside the Router-less /mobile webview (chat-purchase-billing)
          <Avatar
            avatar={props.affiliate.avatar}
            type={EAvatarType.PaymentPopup}
          />
        ))}
        <div className={props.isCompact ? "ml-0" : "ml-4"}>
          {renderIf(!!props.isCompact, {
            ifTrue: () => (
              <h2 className="text-heading font-bold text-body-text">
                Unlock this content
              </h2>
            ),
            ifFalse: () => (
              <h2 className="text-heading font-bold text-body-text">
                Unlock{" "}
                {props.affiliate.display_name || props.affiliate.username}’s
                content
              </h2>
            ),
          })}
          {renderIfTrue(
            !!props.message!.self_destruct && !props.hideExpiry,
            () => (
              <h4 className="mt-1.25 flex items-center gap-1 rounded-3xl border border-warning bg-warning-bg pt-1.25 pr-2.25 pb-1.25 pl-2.25 text-body font-medium text-body-text">
                <span className="text-warning [&_svg]:block [&_svg]:size-3.5">
                  {ICONS_MESSENGER.Timer}
                </span>
                Expires {props.message!.self_destruct_hours || 48} hours after
                opening
              </h4>
            )
          )}
        </div>
      </div>
    );
  }
);
